<template>
  <div class="bg_gray" v-if="isShow">
    <Header :navTitle="nav_title" navPath=""></Header>
    <van-row class="order_info">
      <van-col span="15" v-if="method=='single'">订单编号：{{order_info.order_sn}}</van-col>
      <van-col span="9" class="text-right">{{order_info.created_at_local}}</van-col>
    </van-row>
    <van-radio-group v-model="payment_method" class="pay_type">
      <van-cell-group v-if="order_info.order_amount > 0">
        <van-cell clickable @click="payment_method = 'alipay'">
          <template #title>
            <i class="iconfont icon-iconfontrectangle390 zfb"></i>
            <span class="name">支付宝支付</span>
          </template>
          <template #right-icon>
            <van-radio name="alipay" />
          </template>
        </van-cell>
        <van-cell clickable @click="payment_method = 'wxpay'">
          <template #title>
            <i class="iconfont icon-weixinzhifu wx"></i>
            <span class="name">微信支付</span>
          </template>
          <template #right-icon>
            <van-radio name="wxpay" />
          </template>
        </van-cell>
        <van-cell clickable @click="payment_method = 'offline'">
          <template #title>
            <i class="iconfont icon-tongyong-lianxikefutubiao kf"></i>
            <span class="name">联系客服线下付款</span>
          </template>
          <template #right-icon>
            <van-radio name="offline" />
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group v-if="order_info.order_amount == 0">
        <van-cell clickable @click="payment_method = 'free'">
          <template #title>
            <i class="iconfont"></i>
            <span class="name">无需支付</span>
          </template>
          <template #right-icon>
            <van-radio name="free" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <!-- 商品信息 -->
    <van-cell title="商品信息" :arrow-direction="isOpenDetail ? 'up' : 'down'" is-link @click="isOpenDetail=!isOpenDetail" />
    <div class="items_wrap" v-if="isOpenDetail">

      <!-- 订单列表 -->
      <div class="order_item" v-for="(order_item,index) in mixed_order_list" :key="index"  v-if="method=='mixed'">
        <div class="content">
          <div class="top">
            <div class="left">
              订单编号：{{ order_item.order_sn }}
            </div>
            <div class="right">
              <van-tag color="#999" text-color="#999" round plain type="primary">{{ order_item.type_text }}</van-tag>
            </div>
          </div>
          <div class="bottom">
            <div class="left">
              <span>商品数量：{{ order_item.goods_total_count }}</span>
              <span>商品金额：¥{{ order_item.total_amount }}</span>
              <span>优惠金额：
                 <span v-if="order_item.discount_amount>0">¥{{ order_item.discount_amount }}</span>
                 <span v-else>-</span>
              </span>
              <span v-if="order_info.reduce_amount > 0">客服减免：
                <span v-if="order_item.reduce_amount>0">¥{{ order_item.reduce_amount }}</span>
                <span v-else>-</span>
              </span>
            </div>
            <div class="right">
              <span >实付金额：¥{{order_item.order_amount}}</span><br>
              <span >订单状态：{{order_item.state_text}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 商品列表 -->
      <van-cell-group v-for="(item,index) in order_info.order_goods" :key="index" v-if="method=='single'">
        <van-cell>
          <template #title>
            <!-- 课程 -->
            <div class="course_item_common" v-if="item.goods_type == 'curriculum'">
              <div class="cover" @click="goCurDetail(item.goods_info.cur_uuid)">
                <img :src="item.cur_cover" />
                <span class="hot" v-if="item.cur_label && item.cur_label != 'null'">{{item.cur_label}}</span>
                <span class="tag" v-if="item.cur_type">{{ item.cur_type }}</span>
                <div class="layer" v-if="item.goods_info.state_text != '已上架'">已失效</div>
              </div>
              <div class="content">
                <h4 class="text_ellipsis" :title="item.goods_info.name" @click="goCurDetail(item.goods_info.cur_uuid)">{{ item.goods_info.name }}</h4>
                <div class="info">
                  <span>¥ {{ item.goods_total }}</span>
                  课时：{{ item.chapter_desc }}
                </div>
              </div>
            </div>
            <!-- 会员卡 -->
            <div v-if="item.goods_type == 'vip'">
              <VipCard :vip_card="item.goods_info"
                       :expired_at="item.goods_info.expired_detail_text"
                       :price_visible="false" :btn_buy="false" :btn_detail="false"></VipCard>
            </div>
          </template>
        </van-cell>

        <van-cell>
          <template #title>
            <div class="coupons_select">
              <div class="title">优惠</div>
              <div v-if="item.discount_amount > 0" class="info">
                <div>{{ item.promote_desc }}</div>
                <div v-if="item.expired_days">学习有效期：{{item.expired_days}}天</div>
              </div>
              <div v-else>-</div>
            </div>
          </template>
          <template #value>
            <div v-if="item.discount_amount > 0">
              <div style="color:#f51c21;">-¥{{ item.discount_amount }}</div>
            </div>
          </template>
        </van-cell>
        <van-cell>
          <template #value>
            <div class="text-right"><span style="font-size:12px;color:#999;">实付：</span><span style="color:#f51c21;font-size:16px;">¥ {{ item.amount }}</span></div>
          </template>
        </van-cell>
      </van-cell-group>

      <!-- 总结 -->
      <div class="tip">共 {{ order_info.order_goods_count }} 个商品</div>
      <van-cell-group>
        <van-cell title="商品金额">
          <template #value>
            <div style="color:#666;">¥ {{order_info.total_amount}}</div>
          </template>
        </van-cell>
        <van-cell title="优惠金额">
          <template #value>
            <div style="color:#666;" v-if="order_info.discount_amount > 0">-¥{{order_info.discount_amount}}</div>
            <div style="color:#666;" v-else>-</div>
          </template>
        </van-cell>
        <van-cell title="客服减免" v-if="order_info.reduce_amount > 0">
          <template #value>
            <div style="color:#666;">-¥{{order_info.reduce_amount}}</div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <!-- 总价 -->
    <div class="sheet_fixed_bottom_common">
      实付金额：<span><span>¥</span>{{order_info.order_amount}}</span>
      <van-button type="danger"
                  :disabled="pull_up_payment_process"
                  :loading="pull_up_payment_process"
                  @click="pullUpOrderPayments" round>
        <div v-if="order_info.order_amount > 0">{{ payment_btn_text }}</div>
        <div v-else>完成订单</div>
        <Countdown v-if="method=='single' && order_info.state_text != '待收款'"
                     :remainTime="order_info.cancel_seconds"
                     @countDowmEnd="countDownEnd" class="countdown"></Countdown>
      </van-button>
    </div>
  </div>

  <van-overlay :show="pull_up_payment_process">
      <van-loading size="24px" vertical
                   style="display: flex; align-items: center;justify-content: center;height: 100%;">正在拉起支付, 请稍后 ...</van-loading>
  </van-overlay>

  <a id="c_order_no_refer" HREF="javascript:void(0)" style="display:none;"></a>

</template>

<script>
  import Header from 'components/mobile/common/Header'
  import Countdown from 'components/common/Countdown'
  import VipCard from "components/settlement/VipCard"
  import {detailOrder, cancelOrder, closeOrder, fmtUserOrderInfo} from 'api/settlement/order/user'
  import {fmtOrderInfo} from 'api/settlement/order/admin'
  import {pullUpPayment, queryPayment, confirmMixedPayment} from 'api/settlement/payment/user'
  import {fmtPaymentInfo} from 'api/settlement/payment/admin'
  import { db_time_to_local_fmt } from 'utils/timeutils'
  import { scrollToTop } from "utils/mobile/common"
  import { is_mobile, is_weixin } from 'utils/common'
  import { ElLoading } from 'element-plus'
  import { showConfirmMessageBox, showMessage } from 'api/base/message'
  export default {
    components: {
      Header,
      Countdown,
      VipCard
    },
    data() {
      return {
        nav_title: '选择支付方式',
        isOpenDetail: false,
        method: 'single',
        order_uuid: '',
        payment_uuid: '',
        payment_confirm_key: '',
        mixed_order_list: [],
        dashboard_base_url: null,
        order_uuid_list: [],
        order_info: {},
        payment_method: 'alipay',
        payment_method_text: '支付宝',
        payment_btn_text: '立即支付',
        wxpay_qr_code_url:'',
        alipay_notice_visible: false,
        alipay_notice_msg: '',
        wxpay_query_interval: null,
        isShow: false,
        paymentDialogVisible: false,
        countdown: 10,
        page_from: null,
        pull_up_payment_process: false,
      }
    },
    created() {

      const that = this;

      if (this.$route.params.method != undefined && this.$route.params.method.length > 0) {
        this.method = this.$route.params.method;
      }

      if (!['single', 'mixed'].includes(this.method)) {
        this.$dialog.alert({
          title: '提示',
          message: '非法操作',
        }).then(() => {
          that.goPath('/');
        });
        return;
      }

      if (this.$route.query.from != undefined){
          this.page_from = this.$route.query.from;
      }

      if (this.$route.params.order_uuid != undefined) {

        switch (this.method) {
          case 'single': { // 单个订单支付
            this.order_uuid = this.$route.params.order_uuid;
            this.loadOrderInfo();
            this.nav_title = '选择支付方式';
          } break;
          case 'mixed': { // 组合支付
              this.payment_confirm_key = this.$route.params.order_uuid;
              this.loadPaymentInfo();
              this.nav_title = '批量支付';
          } break;
        }

      }

    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.$nextTick(()=>{
         scrollToTop()
      })
    },
    methods: {
      async loadOrderInfo(){

        this.$emit('update:isShowOverlay', true);

        const that = this;
        await detailOrder(this.order_uuid).then(result => {

          if (result.succeed) {

            that.dashboard_base_url = result.dashboard_base_url;

            let filled_order_info = fmtUserOrderInfo(result.order_info);

            if (!['待支付', '待收款'].includes(filled_order_info.state_text)){
                that.$dialog.alert({
                  title: '提示',
                  message: `当前订单状态为${filled_order_info.state_text}`,
                }).then(()=>{
                  switch(that.page_from){
                    case 'order_center': {
                        window.location.href = '/mobile/center/order/';
                    } break;
                    default: {
                        window.location.href = '/mobile/home/';
                    } break;
                  }
                });
              return;
            }

            if (filled_order_info.state_text === '待支付' && filled_order_info.cancel_seconds <=0 ){

                that.closeOrderByUUID(filled_order_info.uuid);

                return false;
            }

            console.log(filled_order_info);

            that.order_info = filled_order_info;

            if (filled_order_info.order_amount == 0){
                this.payment_method = 'free';
            }

            this.order_uuid_list = [that.order_uuid];

            setTimeout(()=>{
              that.isShow = true;
            }, 300);
          } else {

            switch (result.error_code) {
              case -9999 : {
                window.location.href = `/mobile/login/?next=${encodeURIComponent(location.pathname + location.search)}`;
              }
                break;
              default: {

                window.location.href = '/mobile/center/order';

//                this.$dialog.alert({
//                  title: '提示',
//                  message: `${result.error_msg}`,
//                }).then(() => {
//                  this.goPath('/mobile/center/order');
//                });
              }
                break;
            }


          }

          this.$emit('update:isShowOverlay', false);

        }).catch(err => {

          this.$dialog.alert({
            title: '提示',
            message: `${err}`,
          });

          this.$emit('update:isShowOverlay', false);

        });

      },
      async loadPaymentInfo(){

          const that = this;

          this.$emit('update:isShowOverlay', true);
          await confirmMixedPayment(this.payment_confirm_key).then(result=>{

            if (result.succeed) {

                that.mixed_order_list = [];

                that.order_uuid_list = [];
                result.order_list.forEach(item=>{
                     that.mixed_order_list.push(fmtOrderInfo(item));
                     that.order_uuid_list.push(item.uuid);

                     console.log(item);
                });


                that.order_info = {
                  total_amount: result.total_amount,
                  discount_amount: result.discount_amount,
                  reduce_amount: result.reduce_amount,
                  order_amount: result.order_amount,
                  order_goods_count: result.order_goods_count
                };

                if(result.order_amount === 0){
                    that.payment_method = 'free';
                }

                that.isShow = true;

            } else {


              switch (result.error_code) {
                case -9999 : {

                  window.location.href = `/mobile/login/?next=${encodeURIComponent(location.pathname + location.search)}`;

                }
                  break;
                default: {

                    window.location.href = '/mobile/center/order';

//                  this.$dialog.alert({
//                    title: '提示',
//                    message: `${result.error_msg}`,
//                  }).then(() => {
//                    this.goPath('/mobile/center/order');
//                  });
                }
                  break;
              }

            }

            this.$emit('update:isShowOverlay', false);

          }).catch(err=>{
              showMessage(err, 'error');

            this.$emit('update:isShowOverlay', false);
          });

      },
      goCurDetail(cur_uuid){
        const cur_detail_page = this.$router.resolve({name: 'CourseDetail', params: {uuid: cur_uuid}});
        window.open(cur_detail_page.href, '_blank');
      },
      confirmCancelOrder(order_uuid){

        const self = this;

        this.$confirm('您确定要取消该订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          self.cancelOrderByUUID(order_uuid);
        }).catch(() => {})
      },

      async cancelOrderByUUID(order_uuid){

        const that = this;

        await cancelOrder({'uuid_in': [order_uuid]}).then(result => {

          if (result.succeed) {

              this.goPath(`/mobile/order/result/${order_uuid}`)

          } else {

            this.$dialog.alert({
              title: '提示',
              message: `${result.error_msg}`,
            });
          }

        }).catch(err => {

          this.$dialog.alert({
            title: '提示',
            message: `${err}`,
          });
        });

      },

      async closeOrderByUUID(order_uuid){

        const that = this;

        await closeOrder({'uuid_in': [order_uuid]}).then(result => {

          if (result.succeed) {

              this.goPath(`/mobile/order/result/${order_uuid}`)

          } else {

            this.$dialog.alert({
              title: '提示',
              message: `${result.error_msg}`,
            });

          }

        }).catch(err => {

          this.$dialog.alert({
            title: '提示',
            message: `${err}`,
          });
        });

      },
      goPath(path) {
        this.$router.push(path);
      },
      countDownEnd() {
        this.closeOrderByUUID(this.order_uuid);
      },
      pullUpOrderPayments(){

        const that = this;

        if (this.order_uuid_list.length > 0) {

          if (is_weixin() && this.payment_method === 'alipay') {

            this.$dialog.alert({
              title: '提示',
              message: '微信内部不能使用支付宝进行支付，请复制当前页面链接到系统浏览器进行访问',
            });

            return false;

          }

          this.pull_up_payment_process = true;

          pullUpPayment({
            'order_uuid_in': this.order_uuid_list,
            'payment_type': this.payment_method,
            'is_mobile': true,
            'is_weixin': is_weixin(),
            'front_url': location.href,
          }).then(result=>{

            if (result.succeed) {

                console.log(result);

                let payment_instance = result.payment_instance;
                let payment_url = result.payment_url;

                that.payment_uuid = payment_instance ? payment_instance.uuid: null;

                let online_payment = false;
                switch(this.payment_method){
                  case 'alipay': {
//                      window.open(payment_url);
                      location.href =  payment_url;
                      that.payment_method_text = '支付宝';
                      that.paymentDialogVisible = true;
                      online_payment = true;
                  } break;
                  case 'wxpay': {
                      that.wxpay_qr_code_url = payment_url;
                      that.payment_method_text = '微信支付';
                      that.paymentDialogVisible = true;
                      online_payment = true;

                      if (!is_weixin()){

                        //window.open(payment_url);
                        location.href =  payment_url;

                      } else if (is_weixin()){
                          location.href =  result.oauth_url;
                      }

                      that.wxpay_query_interval = setInterval(that.checkCurrentPaymentState, 3000);

                  } break;
                  case 'offline':
                  case 'free': {
                    this.goPath(`/mobile/order/result/payment/${payment_instance.uuid}`)
                  } break;

                }

                if (online_payment && result.uncashed_mode) {
                  this.order_info.state_text = '待支付';
                  this.order_info.cancel_seconds = result.overdue_seconds;
                }

            } else {

              this.$dialog.alert({
                title: '提示',
                message: `${result.error_msg}`,
              });


            }

            that.pull_up_payment_process = false;

          }).catch(err=>{

            that.pull_up_payment_process = false;

            this.$dialog.alert({
              title: '提示',
              message: `${err}`,
            });

          });

        } else {

          this.$dialog.alert({
            title: '提示',
            message: '未知错误,不能进行支付',
          });
        }



      },
      checkCurrentPaymentState(){

        if (this.payment_uuid){

        const that = this;

        queryPayment(this.payment_uuid).then(result => {

          if (result.succeed) {

            let payment_instance = fmtPaymentInfo(result.instance);

            switch (payment_instance.state_text) {
              case '已收款' : {
                  clearInterval(that.wxpay_query_interval);
                  window.location.href = `/mobile/order/result/payment/${that.payment_uuid}`;
              } break;
              case '待收款' : {
                  if(that.payment_method == 'alipay'){
                      that.alipay_notice_msg = '尚未完成支付, 请先完成支付';
                      that.alipay_notice_visible = true;
                  }
              } break;

              default: {

                this.$dialog.alert({
                  title: '提示',
                  message: `${result.error_msg}`,
                });
              } break;
            }

          } else {

            this.$dialog.alert({
              title: '提示',
              message: `${result.error_msg}`,
            });
          }

        }).catch(err => {

          this.$dialog.alert({
            title: '提示',
            message: `${err}`,
          });

        });

        }

      }

    },
    watch: {
        paymentDialogVisible(val){
            if(!val){
                clearInterval(this.wxpay_query_interval)
            }
        },
        payment_method(val){
          switch (val) {
            case 'alipay':
            case 'wxpay': {
              this.payment_btn_text = '立即支付';
            }
              break;
            case 'offline': {
              this.payment_btn_text = '确定';
            }
              break;
          }
        }
    }
  }
</script>

<style lang="scss" scoped>
  .order_info {
    font-size:12px;
    padding:15px 10px;
  }
  .pay_type {
    margin-bottom:15px;
    .van-cell {
      padding:15px 10px;
    }
    .iconfont {
      font-size:36px;
      vertical-align: middle;
      margin-right:10px;
      &.zfb {
        color:#02a9f1;
      }
      &.wx {
        color:#09bb07;
      }
      &.kf {
        color:#00adef;
      }
    }
    .name {
      color:#666;
    }
  }
  .items_wrap {
    :deep(.van-cell-group) {
      margin-bottom:10px;
      .van-cell {
        padding:10px;
        .van-cell__title {
          min-width:0;
        }
        .course_item_common {
          .cover {
            margin:0 10px 0 0;
          }
          .content {
            padding-top:20px;
            .info {
              > span {
                margin-right:10px;
              }
            }
          }
        }
        .coupons_select {
          display:flex;
          white-space: nowrap;
          .title {
            margin-right:10px;
          }
          .info {
            font-size:12px;
            color:#999;
          }
        }
        &:after {
          left:10px;
          right:10px;
        }
      }
    }
    .tip {
      padding:5px;
      color:#999;
      font-size:12px;
      margin-bottom:5px;
    }
  }
  .sheet_fixed_bottom_common {
    display:flex;
    align-items: center;
    justify-content: flex-end;
    > span {
      margin-left:10px;
      margin-right:15px;
      font-size:32px;
      color:#f51c21;
      font-family: 'font-540';
      > span {
        font-size:18px;
        margin-right:5px;
      }
    }
  }

  .order_item {
    display:flex;
    align-items: center;
    background:#fff;
    padding:15px 10px;
    margin-bottom:10px;
    .check {
      margin-right:10px;
    }
    .content {
      flex:1;
      .top {
        display:flex;
        margin-bottom:10px;
        .left {
          flex:1;
        }
        .right {
          .van-tag {
            padding:2px 10px;
          }
        }
      }
      .bottom {
        .left {
          margin-bottom:10px;
          span {
            font-size:12px;
            color:#999;
            margin-right:10px;
          }
        }
      }
    }
  }
</style>
